import { render, staticRenderFns } from "./PageSize.vue?vue&type=template&id=1a210148&"
import script from "./PageSize.vue?vue&type=script&lang=js&"
export * from "./PageSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports